import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Joyride, { ACTIONS, LIFECYCLE, EVENTS } from 'react-joyride';
import { isEmpty } from 'lodash';
import S from './LPATutorial.scss';

const ADD_INSTALLER_PAY_TUTORIAL = [
  {
    placement: 'top',
    target: '#installerPayTutorial0',
    disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: true,
    title: 'Labor, Product & Accouting',
    content: 'This is where you can add pay to your labor sheet.',
  },
  {
    placement: 'top',
    target: '#header_laborSheet',
    content: 'Here are your Labors Sheets. Please select the contractor who is being paid',
    disableBeacon: true,
    disableOverlayClose: true,
    spotlightClicks: true,
    hideBackButton: true,
    hideCloseButton: false,
  },
  {
    placement: 'top-end',
    target: '#installerPayTutorial2',
    content: 'You can click the "EDIT" button here to start',
    disableBeacon: true,
    disableOverlayClose: true,
    spotlightClicks: true,
  },
  {
    placement: 'bottom',
    target: '#installerPayTutorial3',
    content: 'Add the line item, quantity, pay rates, and a note. Click the "SAVE" button to finish.',
    spotlightClicks: true,
    disableBeacon: true,
    disableOverlay: true,
  },
  {
    placement: 'top',
    target: '#laborSheet_done',
    content: 'Click the "DONE" button here where you are finished',
    disableBeacon: true,
    disableOverlayClose: true,
    spotlightClicks: true,
    hideCloseButton: true,
    disableScrolling: false,
  },
];

class LPATutorial extends Component {
  constructor(props) {
    super(props);

    this.state = {
      run: false,
      stepIndex: 0,
      continuous: true,
      runStep2: false,
      step3Ref: {},
    };

    this.restartTutorial = this.restartTutorial.bind(this);
    this.runStep3 = this.runStep3.bind(this);
  }

  runStep3 = () => {
    const { run, stepIndex } = this.state;
    if (run && stepIndex === 2) {
      setTimeout(() => this.setState({ stepIndex: stepIndex + 1, continuous: true }), 500);
    }
  }

  restartTutorial = () => this.setState({ buildIndex: 0, run: true, continuous: true });

  isStepComplete = (action, lifecycle) => (
    action === ACTIONS.NEXT &&
    lifecycle === LIFECYCLE.COMPLETE
  );

  isStepReady = (action, lifecycle) => (
    action === ACTIONS.NEXT &&
    lifecycle === LIFECYCLE.READY
  );

  didTutorialClose = action => action === ACTIONS.CLOSE;

  changeStep = index => this.setState({ buildIndex: index });

  // This allows more programmatically control over joyride
  // data is props passed from Joyride, while tutorial is running
  handleJoyrideSteps = (data) => {
    const { action, index, lifecycle, type } = data;
    // This opens the laborsheet table when user clicks next on first step
    if (index === 0 && this.isStepComplete(action, lifecycle)) {
      const headerBtn = document.getElementById('header_laborSheet') || {};
      if (!isEmpty(headerBtn)) headerBtn.click();
      this.setState({ stepIndex: index + 1 });
    } else if (index === 1 && this.isStepReady(action, lifecycle)) {
      this.setState({ continuous: false });
    } else if (index === 2 && action === ACTIONS.PREV) {
      this.props.toggleStep2();
      this.setState({ stepIndex: 1, continuous: false, runStep2: false });
    } else if (index === 2 && this.isStepComplete(action, lifecycle)) {
      const editBtn = document.getElementById('laborSheet_edit') || {};
      if (!isEmpty(editBtn)) { editBtn.click(); }
      setTimeout(() => this.setState({ stepIndex: index + 1, continuous: true }), 500);
    } else if (index === 3 && this.isStepComplete(action, lifecycle)) {
      this.setState({ stepIndex: index + 1 });
    } else if (index === 4 && this.isStepComplete(action, lifecycle)) {
      this.setState({ stepIndex: 0, run: false });
    } else if (this.didTutorialClose(action)) {
      this.setState({ stepIndex: 0, run: false, continuous: true });
    } else if (type === EVENTS.TARGET_NOT_FOUND) { // skip if target isnt mounted
      this.setState({ stepIndex: index + 1 });
    } else if (type === EVENTS.STEP_AFTER) { // this make sure back buttons work
      this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });
    }
  }

  render = () => {
    const { run, continuous, stepIndex } = this.state;
    if (stepIndex === 1 && this.props.runStep2) {
      this.setState({ stepIndex: 2, run: true, continuous: true });
    }

    return (
      <div>
        <button id="tutorialRestartBtn" className={S.joyrideBtn} type="button" onClick={this.restartTutorial} />
        <button id="runStep3Btn" className={S.joyrideBtn} type="button" onClick={this.runStep3} />
        <Joyride
          steps={ADD_INSTALLER_PAY_TUTORIAL}
          stepIndex={stepIndex}
          continuous={continuous} // allows next button
          run={run} // toggles the tour
          showProgress
          disableOverlayClose // doesnt close when clicked outside
          disableBeacon // clickable red dot that toggles the tutorial
          callback={this.handleJoyrideSteps}
        />
      </div>
    );
  }

}

LPATutorial.propTypes = {
  run: PropTypes.bool,
  runStep2: PropTypes.bool,
  toggleStep2: PropTypes.func,
};

export default LPATutorial;



// WEBPACK FOOTER //
// ./client/app/shared/components/SpotJoyride/LPATutorial.jsx